import { action, observable } from 'mobx';

const LOCAL_STORAGE_KEY_LATITUDE = 'alo-users-latitude';
const LOCAL_STORAGE_KEY_LONGITUDE = 'alo-users-longitude';
const LOCAL_STORAGE_KEY_ZIPCODE = 'alo-users-zipcode';
const LOCAL_STORAGE_KEY_SDD_ZIPCODE = 'alo-users-sdd-zipcode';
const selectedLatitudeFromLS = localStorage.getItem(LOCAL_STORAGE_KEY_LATITUDE);
const selectedLongitudeFromLS = localStorage.getItem(LOCAL_STORAGE_KEY_LONGITUDE);
const selectedZipcodeFromLS = localStorage.getItem(LOCAL_STORAGE_KEY_ZIPCODE);
const selectedSddZipcodeFromLS = localStorage.getItem(LOCAL_STORAGE_KEY_SDD_ZIPCODE);

export const customerLocationState = observable({
  coordinates:
    selectedLatitudeFromLS && selectedLongitudeFromLS
      ? {
          latitude: selectedLatitudeFromLS,
          longitude: selectedLongitudeFromLS,
        }
      : null,
  zip: selectedZipcodeFromLS ?? null,
  sddZip: selectedSddZipcodeFromLS ?? null, //Same day delivery zipcode
  apiError: false,
});

export const setCustomerLatLongLocation = action((latitude: string, longitude: string) => {
  customerLocationState.coordinates = { latitude, longitude };
  localStorage.setItem(LOCAL_STORAGE_KEY_LATITUDE, latitude);
  localStorage.setItem(LOCAL_STORAGE_KEY_LONGITUDE, longitude);
});

export const resetCustomerLatLongLocation = action(() => {
  customerLocationState.coordinates = null;
  localStorage.removeItem(LOCAL_STORAGE_KEY_LATITUDE);
  localStorage.removeItem(LOCAL_STORAGE_KEY_LONGITUDE);
});

export const setCustomerZipcode = action((zipcode: string) => {
  customerLocationState.zip = zipcode;
  localStorage.setItem(LOCAL_STORAGE_KEY_ZIPCODE, zipcode);
});

export const resetCustomerZipcode = action(() => {
  customerLocationState.zip = null;
  localStorage.removeItem(LOCAL_STORAGE_KEY_ZIPCODE);
});

export const setCustomerSddZipcode = action((zipcode: string) => {
  customerLocationState.sddZip = zipcode;
  localStorage.setItem(LOCAL_STORAGE_KEY_SDD_ZIPCODE, zipcode);
});

export const setCustomerLocationErrorState = action((isError: boolean) => {
  customerLocationState.apiError = isError;
});
